import { NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';

@NgModule()
export class IconsModule {
  /**
   * Constructor
   */
  constructor(
    private _domSanitizer: DomSanitizer,
    private _matIconRegistry: MatIconRegistry
  ) {
    // Register icon sets
    this._matIconRegistry.addSvgIconSet(this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/material-outline.svg'));
    this._matIconRegistry.addSvgIconSetInNamespace('mat_outline', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/material-outline.svg'));
    this._matIconRegistry.addSvgIconSetInNamespace('mat_twotone', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/material-twotone.svg'));
    this._matIconRegistry.addSvgIconSetInNamespace('mat_solid', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/material-solid.svg'));
    this._matIconRegistry.addSvgIconSetInNamespace('iconsmind', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/iconsmind.svg'));
    this._matIconRegistry.addSvgIconSetInNamespace('feather', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/feather.svg'));
    this._matIconRegistry.addSvgIconSetInNamespace('heroicons_outline', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/heroicons-outline.svg'));
    this._matIconRegistry.addSvgIconSetInNamespace('heroicons_solid', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/heroicons-solid.svg'));
    this._matIconRegistry.addSvgIconSetInNamespace('heroicons_mini', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/heroicons-mini.svg'));
    this._matIconRegistry.addSvgIconSetInNamespace('icomoon', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/icomoon.svg'));

    // this._matIconRegistry.addSvgIcon('cash_register', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/cash_register.svg'));
    // this._matIconRegistry.addSvgIcon('draft', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/draft.svg'));
    // this._matIconRegistry.addSvgIcon('draft_email', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/draft_email.svg'));
    // this._matIconRegistry.addSvgIcon('invoice', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/invoice.svg'));
    // this._matIconRegistry.addSvgIcon('invoice_email', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/invoice_email.svg'));
  }
}
